// 在另一个页面退出登录，和登录的时候触发刷新其他页面
export const localStorageKey = 'loginOrLogout'

export const windowCommunication = {
  init: () => {
    // 窗口监听storage事件
    window.addEventListener('storage', (e) => {
      // IE 浏览器在当前窗口也会触发事件，跟其他浏览器行为不一致，这里做一下兼容
      if (document.hasFocus()) {
        return
      }
      // 登录、退出
      if (e.key === localStorageKey) {
        location.reload()
      }
    })
  },
  // 触发storage事件
  trigger: (type = localStorageKey) => {
    localStorage.setItem(type, Math.random().toString())
  },
}

export class CustomBroadcast {
  constructor(type) {
    this.type = type
    this.broadcastChannel = new BroadcastChannel(type)
  }
  postMessage(params) {
    this.broadcastChannel.postMessage({ type: this.type, data: params })
  }
  listenerMessage() {
    this.broadcastChannel.addEventListener('message', () => {
      // console.log(event, 'ev')
      location.reload()
    })
  }
}

export const broadcastChannel = new CustomBroadcast(localStorageKey)
